const tooltipValidationMessages = {
  newness_filters_with_months: "Please select Country, Brand, Channel and Months to select newness",
  newness_filters: "Please select Country, Brand and Channel to select newness",
  select_newness: "Please select at least one newness to continue",
  new_process: "Allocation process is ongoing. Submitting now will start new allocation process",
};

export default tooltipValidationMessages;
